import { useState } from 'react';
import { versionList } from '@/mocks/updates';
import { newsList } from '@/mocks/news';
import PageHeader from '@/components/feature/PageHeader';
import ArticleCard from '@/components/feature/ArticleCard';
import VersionList from '@/pages/updates/components/VersionList';
import VersionDetail from '@/pages/updates/components/VersionDetail';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Updates() {
  usePageMeta({
    title: '原神版本更新记录 - 详细补丁说明',
    description:
      '原神版本更新记录集中展示各版本的补丁说明、系统调整与新增内容，支持切换查看版本亮点与玩法改动，快速掌握版本变化。',
    keywords: '原神版本更新,补丁说明,版本前瞻,版本亮点,原神更新',
  });

  const [activeVersion, setActiveVersion] = useState(versionList[0].version);
  const active = versionList.find((v) => v.version === activeVersion) ?? versionList[0];

  const recommended = active.recommendedIds
    .map((rid) => newsList.find((a) => a.id === rid))
    .filter((a): a is (typeof newsList)[number] => Boolean(a));

  return (
    <div>
      <PageHeader
        crumbs={[{ label: '首页', to: '/' }, { label: '版本更新' }]}
        icon="ri-rocket-2-line"
        title="版本更新专题"
        description="集中展示原神各版本的上线时间、更新简介与补丁说明，点击左侧版本列表即可切换查看详细改动。"
      />

      <div className="container-page py-8 md:py-12">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-[88px]">
              <VersionList
                versions={versionList}
                activeVersion={activeVersion}
                onSelect={setActiveVersion}
              />
            </div>
          </div>
          <div className="lg:col-span-2">
            <VersionDetail version={active} />
          </div>
        </div>

        {recommended.length > 0 && (
          <section className="mt-12 md:mt-14">
            <div className="mb-6 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                <i className="ri-book-open-line"></i>
              </span>
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-950">相关攻略推荐</h2>
                <p className="text-xs text-foreground-500">
                  结合 {active.version} {active.name} 整理的实用内容
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {recommended.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}